import { AdminPermissionKey, UserRules } from '@uplift/types';
import { restClient } from '../../client';
import { ProviderDetail, User, UserProfile } from '../../resources';
import { Asset } from '../../resources/asset';
import { HigherEdOrg } from '../higherEd';


export type GetMeOutput = {
  data: {
    user: User;
    profile?: UserProfile;
    avatarAsset?: Asset;
    providerDetails?: ProviderDetail;
    rules?: UserRules;
    isImpersonated?: boolean;
    higherEdOrg?: HigherEdOrg;
    permissions?: AdminPermissionKey[];
  };
};


export const getMe = (opts?: { refreshAuth?: boolean }) => restClient.request<GetMeOutput>(
  '/api/v1/auth/me',
  {
    method: 'GET',
  },
  opts?.refreshAuth
);
